import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState } from '@/modules/marketplace/marketplaces/store/marketplaceSlice/initialState.ts'

const marketplaceSlice = createSlice({
  name: 'marketplaces',
  initialState,
  reducers: {
    setIsCreateModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isCreateModalOpen = action.payload
    },
    setEditId: (state, action: PayloadAction<number | null>) => {
      state.editId = action.payload
    },
    setFilters: (state, action: PayloadAction<string>) => {
      state.filters = action.payload
    },
    reset: () => initialState
  }
})

export const marketplaceActions = marketplaceSlice.actions
export const { reducer: marketplaceReducer } = marketplaceSlice
